module.exports = __webpack_public_path__ + "static/media/S1N6.558a6ae8.svg";